import React from "react";

import InputMask from "inputmask";

import { InputContainer } from "./styles";

class Input extends React.Component {
  state = {
    ref: React.createRef()
  };
  componentDidMount() {
    const { ref } = this.state;

    let input = ref.current;

    let im = new InputMask(this.props.mask, { showMaskOnHover: false });

    im.mask(input);
  }
  render() {
    const { ref } = this.state;
    return (
      <InputContainer>
        <label>{this.props.label || this.props.placeholder}</label>
        <input
          ref={ref}
          {...this.props}
          onWheel={(e) => {
            if (this.props.type === 'number') {
              e.preventDefault();
              e.currentTarget.blur();
            }
            if (this.props.onWheel) this.props.onWheel(e);
          }}
          onKeyDown={(e) => {
            if (this.props.type === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
              e.preventDefault();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
          }}
        ></input>
        {this.props.unidade? (
          <label className="unidadeDose"> {this.props.unidade} </label>
        ):(null)}
      </InputContainer>
    );
  }
}

export default Input;
